import { inject, Injectable } from '@angular/core';
import { AppService } from '../app.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FirebaseMode, IAppParams, Products } from 'src/app/interfaces/state-interface';
import { BehaviorSubject } from 'rxjs';
import { StoreService } from '../store/store.service';
import { replace } from 'lodash-es';

@Injectable({
  providedIn: 'root',
})
export class QueryParamService {
  private router: Router = inject(Router);
  private route: ActivatedRoute = inject(ActivatedRoute);

  private appService: AppService = inject(AppService);
  private storeService: StoreService = inject(StoreService);

  queryParams: IAppParams = {};
  $queryParams: BehaviorSubject<IAppParams> = new BehaviorSubject(
    this.queryParams
  );

  constructor() {}
  initReadingParams() {
    setTimeout(() => {
      const qp:any = this.route.snapshot.queryParamMap;
      
      this.queryParams.firstName = qp.get('fullName') || '';
      this.queryParams.userId = qp.get('id') || '';
      this.queryParams.code = qp.get('code') || '';
      this.queryParams.email = qp.email ? replace(decodeURIComponent(qp.email), / /g, '+') : '';
      this.queryParams.product = (
        qp.get('productName') ||
        qp.get('productType') ||
        ''
      ).toUpperCase() as Products;

      this.queryParams.redirectURL = qp.get('redirectTo') || '';
      this.queryParams.productType = qp.get('productType') || '';
      const mode: string = qp.get('mode') || '';
      this.queryParams.mode = mode as FirebaseMode;
      this.queryParams.oobCode = qp.get('oobCode') || '';
      this.queryParams.lang = qp.get('lang') || '';
      this.queryParams.continueUrl = qp.get('continueUrl') || '';
      this.$queryParams.next(this.queryParams);
      this.storeService.setProduct(this.queryParams.product ? Products[this.queryParams.product] : Products.SARAS);
    }, 100);
  }

  
}
